import { normalizeOrderPlatform } from "@/utils/orderV2";
import { LanguageEnum, languageLabel } from "@/pages/CreateCampaign/shared/config";

interface MismatchChannel {
  channelKey: string;
  platform: string;
  platformId: string;
  influencerId: number;
  displayName?: string;
  followers?: number;
  userName?: string;
  profileLink?: string;
  profilePictureLink?: string;
  language?: string;
  price?: number;
  lastPrice?: number;
  predictedCpm?: number;
  mismatchReasons: string[];
  mismatchReasonLabels: string[];
  // The backend owns the threshold detail schema; preserve it as supplied.
  reasonDetails?: unknown[];
}

// Use each channel's own fields, including the richer metrics now returned by
// the API. Do not copy order-level metrics or reasons into channel rows.
export const buildMismatchChannelRows = (order: any) =>
  (Array.isArray(order.channels) ? order.channels : []).map(
    (channel: MismatchChannel) => ({
      ...channel,
      id: order.id,
      campaignId: order.campaignId,
      platform: normalizeOrderPlatform(channel.platform) ?? channel.platform,
      creatorName: channel.displayName || channel.platformId,
      creatorLanguage: channel.language,
      mismatchReasonLabels: channel.mismatchReasonLabels?.map((label, index) =>
        channel.mismatchReasons?.[index] === "language_mismatch" && channel.language
          ? label.replace(
              /\bunknown\b/gi,
              () => languageLabel[channel.language as LanguageEnum] || channel.language!,
            )
          : label,
      ),
      creatorProfileLink: channel.profileLink,
      creatorProfilePictureLink:
        channel.profilePictureLink || order.creatorProfilePictureLink || order.avatarUrl,
      lastPrice: channel.lastPrice ?? channel.price,
      predictedCpm: channel.predictedCpm != null && channel.predictedCpm >= 0
        ? channel.predictedCpm
        : undefined,
    }),
  );
